import classnames from 'classnames';
import React, { useEffect, useRef } from 'react';

const CSS = require('./Banner.module.scss');

interface BannerButton {
  label: string;
  onClick: () => void;
  isDefault?: boolean;
  className?: string;
}

interface BannerProps {
  children: React.ReactNode;
  buttons?: BannerButton[];
  className?: string;
  onShow?: () => void;
}

let activeBannerToken: symbol | null = null;

function Banner({ children, buttons = [], className, onShow }: BannerProps) {
  const idRef = useRef(Symbol('Banner'));
  const token = idRef.current;
  const hasShownRef = useRef(false);

  if (!activeBannerToken) {
    activeBannerToken = token;
  }

  useEffect(() => {
    if (activeBannerToken === token && !hasShownRef.current) {
      hasShownRef.current = true;
      onShow && onShow();
    }
  }, [onShow, token]);

  useEffect(() => {
    return () => {
      if (activeBannerToken === token) {
        activeBannerToken = null;
      }
    };
  }, [token]);

  const isOwner = activeBannerToken === token;
  if (!isOwner) return null;

  return (
    <section className={classnames(CSS.Banner, className)}>
      <div className={CSS.Text}>{children}</div>
      <div className={CSS.ControlBar}>
        {buttons.map((button: BannerButton, index: number) => (
          <button
            key={`${button.label}_${index}`}
            className={classnames(
              CSS.Button,
              { [CSS.DefaultButton]: button.isDefault },
              button.className,
            )}
            onClick={button.onClick}
          >
            {button.label}
          </button>
        ))}
      </div>
    </section>
  );
}

export default Banner;
